<template>
  <div v-show="visible" class="toast-mask">
    <div class="toast-box">
      <div v-if="iconType" class="toast-icon">
        <i v-if="iconType === 'success'" class="el-icon-success"></i>
        <i v-else-if="iconType === 'error'" class="el-icon-error"></i>
        <i v-else-if="iconType === 'loading'" class="el-icon-loading"></i>
      </div>
      <div class="toast-text">{{ message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      visible: false,
      message: '',
      iconType: '', // success / error / loading / ''
      timer: null
    }
  },
  methods: {
    show(options) {
      this.visible = true
      this.message = options.message || ''
      this.iconType = options.icon || ''
      clearTimeout(this.timer)

      if (this.iconType !== 'loading') {
        this.timer = setTimeout(() => {
          this.visible = false
        }, options.duration || 2000)
      }
    },
    hide() {
      this.visible = false
      clearTimeout(this.timer)
    }
  }
}
</script>

<style scoped>
.toast-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.toast-box {
  max-width: 240px;
  min-width: 100px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  border-radius: 10px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
}
.toast-icon {
  font-size: 26px;
  margin-bottom: 8px;
}
.toast-text {
  line-height: 1.4;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/toast/toast.vue